/**
 * Position a `position: fixed` tooltip panel relative to its trigger.
 *
 * Both rects are viewport-relative (getBoundingClientRect); the returned
 * top/left are viewport coordinates and must NOT include scroll offsets —
 * fixed elements don't move with the document (RAC-10392: adding scrollY
 * pushed tooltips below the fold on the scrolled pricing page).
 *
 * Prefers above the trigger, flips below when there's no room, and clamps
 * horizontally inside the viewport with an 8px gutter.
 */
export function computeTooltipPosition({ triggerRect, tooltipRect, viewportWidth, margin = 12, gutter = 8 }) {
    let top = triggerRect.top - tooltipRect.height - margin
    if (top < gutter) {
        top = triggerRect.bottom + margin
    }

    let left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2
    const maxLeft = viewportWidth - tooltipRect.width - gutter
    left = Math.min(Math.max(left, gutter), maxLeft)

    return { top, left }
}
